import React from "react";
import { Component } from "react";
import strings from "../resources/strings";
import { currentQuestion } from "../state/questionStates";
import QuestionLabel from "./question/QuestionLabel";
import SurveyCode from "./SurveyCode";
import { has } from 'lodash';

class Complete extends Component {
    render() {
        let state = this.props.store.getState();
        let current = currentQuestion(state);

        let className = "w3-header" + (has(current, "class") ? " " + current.class : " w3-center");

        return (
            <div className="form w3-header w3-animate-opacity">
                <div className={className}>
                    <h2 id="complete">{strings.getString("complete")}</h2>
                    <QuestionLabel question={current} store={this.props.store}/>
                    <SurveyCode question={current} store={this.props.store}/>
                </div>
            </div>
        );
    }
}

export default Complete;
